import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Footer from './components/feature/Footer';

const SUPABASE_PING_URL = 'https://jnfxtdeihywibelqiiqg.supabase.co/health';
const PING_INTERVAL_MS = 3 * 24 * 60 * 60 * 1000; // 3 days

function useSupabasePing() {
  useEffect(() => {
    const lastPing = localStorage.getItem('supabase_last_ping');
    const now = Date.now();

    if (!lastPing || now - Number(lastPing) > PING_INTERVAL_MS) {
      fetch(SUPABASE_PING_URL, { method: 'GET', mode: 'no-cors' })
        .then(() => {
          localStorage.setItem('supabase_last_ping', String(now));
        })
        .catch(() => {
          // Silent fail — ping is best-effort
        });
    }
  }, []);
}

function App() {
  useSupabasePing();

  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen flex flex-col">
        <main className="flex-grow">
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
